import querystring from 'query-string'

export const parseListParams = (locationSearch) => {
    let parsed = querystring.parse(locationSearch)
    let page = parsed.page? parseInt(parsed.page) : 1
    let searchKeyword = parsed.searchKeyword? parsed.searchKeyword : ''
    let role = parsed.role? parsed.role: 'all'

    return {
        page: page,
        searchKeyword: searchKeyword,
        role: role
    }
}
